import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { API_BASE } from "@/lib/api";

async function getRegions(level, parent) {
  const r = await fetch(`${API_BASE}/regions/${level}/${parent || "all"}`, { headers: { Accept: "application/json" } });
  if (!r.ok) throw new Error("gagal memuat");
  return (await r.json()).data || [];
}

const selCls = "w-full h-11 px-3 rounded-xl border border-blush-soft text-sm bg-white focus:outline-none focus:ring-2 ring-brand disabled:opacity-50";

export default function AddressRegionFields({ onChange, testPrefix = "region" }) {
  const [prov, setProv] = useState([]);
  const [reg, setReg] = useState([]);
  const [dis, setDis] = useState([]);
  const [vil, setVil] = useState([]);
  const [sel, setSel] = useState({ province: null, city: null, district: null, village: null });
  const [detail, setDetail] = useState("");
  const [postal, setPostal] = useState("");
  const [loading, setLoading] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    getRegions("provinces").then(setProv).catch(() => setErr("Gagal memuat data provinsi. Cek koneksi lalu muat ulang."));
  }, []);

  const emit = (nextSel, d = detail, p = postal) => {
    const { province, city, district, village } = nextSel;
    const composed = village && district && city && province
      ? `${d ? d.trim() + ", " : ""}${village.name}, Kec. ${district.name}, ${city.name}, ${province.name}${p ? " " + p : ""}`
      : "";
    onChange({
      province: province?.name || "", city: city?.name || "", district: district?.name || "", village: village?.name || "",
      detail: d, postal_code: p, composed,
      complete: !!(province && city && district && village && d.trim()),
    });
  };

  const pick = async (level, code, items) => {
    const found = items.find((x) => x.code === code) || null;
    const next = { ...sel, [level]: found };
    if (level === "province") { next.city = null; next.district = null; next.village = null; setReg([]); setDis([]); setVil([]); }
    if (level === "city") { next.district = null; next.village = null; setDis([]); setVil([]); }
    if (level === "district") { next.village = null; setVil([]); }
    setSel(next);
    setErr("");
    emit(next);
    if (!found) return;
    const childMap = { province: ["regencies", setReg], city: ["districts", setDis], district: ["villages", setVil] };
    const child = childMap[level];
    if (!child) return;
    setLoading(level);
    try {
      child[1](await getRegions(child[0], found.code));
    } catch {
      setErr("Data wilayah gagal dimuat, coba pilih ulang.");
    } finally { setLoading(""); }
  };

  return (
    <div className="space-y-2.5">
      <select data-testid={`${testPrefix}-province`} value={sel.province?.code || ""} onChange={(e) => pick("province", e.target.value, prov)} className={selCls}>
        <option value="" disabled>Pilih Provinsi</option>
        {prov.map((p) => <option key={p.code} value={p.code}>{p.name}</option>)}
      </select>
      <select data-testid={`${testPrefix}-city`} value={sel.city?.code || ""} onChange={(e) => pick("city", e.target.value, reg)} disabled={!sel.province} className={selCls}>
        <option value="" disabled>{loading === "province" ? "Memuat..." : "Pilih Kota/Kabupaten"}</option>
        {reg.map((r) => <option key={r.code} value={r.code}>{r.name}</option>)}
      </select>
      <select data-testid={`${testPrefix}-district`} value={sel.district?.code || ""} onChange={(e) => pick("district", e.target.value, dis)} disabled={!sel.city} className={selCls}>
        <option value="" disabled>{loading === "city" ? "Memuat..." : "Pilih Kecamatan"}</option>
        {dis.map((d) => <option key={d.code} value={d.code}>{d.name}</option>)}
      </select>
      <select data-testid={`${testPrefix}-village`} value={sel.village?.code || ""} onChange={(e) => pick("village", e.target.value, vil)} disabled={!sel.district} className={selCls}>
        <option value="" disabled>{loading === "district" ? "Memuat..." : "Pilih Kelurahan/Desa"}</option>
        {vil.map((v) => <option key={v.code} value={v.code}>{v.name}</option>)}
      </select>
      <textarea
        data-testid={`${testPrefix}-detail`}
        value={detail}
        onChange={(e) => { setDetail(e.target.value); emit(sel, e.target.value); }}
        placeholder="Detail: nama jalan, RT/RW, no. rumah, patokan"
        rows={2}
        className="w-full px-3 py-2 rounded-xl border border-blush-soft text-sm focus:outline-none focus:ring-2 ring-brand"
      />
      <input
        data-testid={`${testPrefix}-postal`}
        value={postal}
        onChange={(e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 5); setPostal(v); emit(sel, detail, v); }}
        placeholder="Kode pos (opsional)"
        inputMode="numeric"
        className="w-full h-11 px-3 rounded-xl border border-blush-soft text-sm focus:outline-none focus:ring-2 ring-brand"
      />
      {loading && <div className="flex items-center gap-2 text-xs text-cocoa-muted"><Loader2 className="w-3.5 h-3.5 animate-spin" /> Memuat data wilayah...</div>}
      {err && <div className="text-xs text-red-500">{err}</div>}
    </div>
  );
}
